import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/fronteu/ampmworldfrontend/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/src/components/entities/error/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ButtonLink"] */ "/home/fronteu/ampmworldfrontend/src/components/ui/button/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/fronteu/ampmworldfrontend/src/components/ui/header-background/index.module.scss");
